
const POS_NOUN = ['?', 'N', 'NNG', 'NNP', 'NP', 'Noun']
const POS_VERB = ['?', 'V', 'VV', 'Verb']
const POS_ADJECTIVE = ['?', 'A', 'AJ', 'VA', 'Adjective']

const NAME_NOUN = '명사'
const NAME_VERB = '동사'
const NAME_ADJECTIVE = '형용사'

const COLOUR_NOUN = '#69b3a2'
const COLOUR_VERB = '#b369a2'
const COLOUR_ADJECTIVE = '#a2b369'

const posToName = (pos) => POS_NOUN.includes(pos) ? NAME_NOUN : POS_VERB.includes(pos) ? NAME_VERB : POS_ADJECTIVE.includes(pos) ? NAME_ADJECTIVE : null
const posColour = (pos) => POS_NOUN.includes(pos) ? COLOUR_NOUN : POS_VERB.includes(pos) ? COLOUR_VERB : POS_ADJECTIVE.includes(pos) ? COLOUR_ADJECTIVE : null

module.exports = {posToName, posColour, COLOUR_NOUN, COLOUR_VERB, COLOUR_ADJECTIVE, POS_NOUN, POS_VERB, POS_ADJECTIVE}
